import { Card } from '@mui/material'
import styled from 'styled-components/macro'

const CustomCard = styled(Card)`
  max-width: 40rem;
  margin: 2rem auto 0;
`

export default CustomCard
